export class NewUserRequest {
  body: NewUserRequestBody = new NewUserRequestBody();
}

export class NewUserRequestBody {
  "ProcessName": string = "DC Create Update New User SR WF";
  "Login Name": string = "";
  "DC Method": string = "SUBMIT";
  "DC Channel": string = "Online";
  "DC Payment Method": string = "Online";
  "SR Type": string = "User Management";
  "SR Sub Type": string = "New User";
  "Account Id": string = "";
  "Member Name English": string = "";
  "Member Name Arabic": string = "";
  "DC Residence of UAE": string = "";
  "Emirates Id": string = "";
  "Date of Birth": string = "";
  "DC Passport Number": string = "";
  "ID Expiration Date": string = "";
  "DC Nationality": string = "";
  "Email Address": string = "";
  "Home Phone #": string = "";
  "DC License Issuing Authority": string = "";
  "SR Number": string = "";
  "Language": string = "ENU";
  "SiebelMessage": NewUserSiebelMessage = new NewUserSiebelMessage();
}

export class NewUserSiebelMessage {
  "MessageType": string = "Integration Object";
  "IntObjectName": string = "DCUpdateUserRegIO";
  "IntObjectFormat": string = "Siebel Hierarchical";
  "ListOfDCUpdateUserRegIO": NewUserUpdateUserRegIOList =
    new NewUserUpdateUserRegIOList();
}

export class NewUserUpdateUserRegIOList {
  "Update User Registration Details": NewUserRegistrationDetails =
    new NewUserRegistrationDetails();
}

export class NewUserRegistrationDetails {
  "Account Id": string = "";
  "DC Business Expected Benefits": string = "";
  "DC Dubai Based": string = "";
  "DC Registration Company Name": string = "";
  "DC Registration Manager Role": string = "";
  "DC Registration Owner Role": string = "";
  "DC Registration Rep Role": string = "";
  "Id": string = "";
}
